import { Box, Divider } from '@material-ui/core';
import { SETVIImage, SHighlightText } from '@setvi/shared/components';
import { TextColor } from '@setvi/shared/enums';
import { toTitleCase } from '@setvi/shared/utils/formatCustomerData';
import { ModifiableProduct } from 'pages/sales/modules/orders/subpages/orders/subpages/order-create';

interface ProductNameCellProps {
  product: ModifiableProduct;
  searchQuery?: string;
}

export const ProductNameCell = ({
  product,
  searchQuery
}: ProductNameCellProps) => {
  const vendorName =
    (product?.vendor as any)?.name || (product?.vendor as any)?.Name || 'N/A';
  const mfgSku = product?.manufacturerSku
    ? ` (SKU: ${product.manufacturerSku})`
    : '';

  return (
    <Box display="flex" alignItems="center" gridGap={12}>
      <SETVIImage
        src={product?.imageUrl || '/images/product-placeholder.svg'}
        alt={product?.name || 'Product'}
        width={56}
        height={56}
        radius={8}
        fit="contain"
        style={{
          backgroundColor: '#FFFFFF',
          border: '1px solid #AFBAC6',
          flexShrink: 0
        }}
      />
      <Box display="flex" flexDirection="column" gridGap={4} minWidth={0}>
        <SHighlightText
          value={toTitleCase(product?.name || '-')}
          weight="semibold"
          searchQuery={searchQuery}
          maxLines={2}
        />
        <Box display="flex" alignItems="center" gridGap={8}>
          <SHighlightText
            size="sm"
            fontColor={TextColor.SlateGrey}
            value={`SKU: ${product?.sku || '-'}`}
            searchQuery={searchQuery}
          />
          <Divider
            orientation="vertical"
            flexItem
            style={{ height: 12, alignSelf: 'center' }}
          />
          <SHighlightText
            size="sm"
            fontColor={TextColor.SlateGrey}
            value={`MFG: ${vendorName}${mfgSku}`}
            searchQuery={searchQuery}
          />
          {product?.minimumQuoteQuantity > 1 && (
            <>
              <Divider
                orientation="vertical"
                flexItem
                style={{ height: 12, alignSelf: 'center' }}
              />
              <SHighlightText
                size="sm"
                fontColor={TextColor.SlateGrey}
                value={`MOQ: ${product.minimumQuoteQuantity}`}
                searchQuery={searchQuery}
              />
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
};
